let ERRCODE = 900

module.exports = {
  FA_INVALID_TYPE: {
    err: ERRCODE++,
    msg: 'invalid type'
  }
}
